export default {
  联系我们: 'Contact Us',
  播放视频: 'Play',
  智能一键采购: 'Personalized Recommendation',
  找不到匹配的产品一键帮您采购下单: "Can't find what you are looking for? Let us help!",
  产品规格: 'Product Specifications',
  规格: 'Specifications',
  价格面议: 'Price Negotiable',
  元: 'Yuan',
  起售: 'Min Order Qty',
  总数: 'Total Number',
  已选清单: 'View Shopping Cart',
  服务与承诺: 'Service and Commitment',
  品牌: 'Brand',
  '3D产品': '360° Product Photos',
  意向采购下单: 'Place Order',
  你可能还喜欢: 'Recommended for You',
  分析匹配的展品说明:
    'Based on your interested industries and browsing history, we recommend to you the following exhibits.',
  '企业云展系统（产品详情页）': 'Home',
  采购单确认: 'Confirm Order',
  供货: 'Supply',
  货品金额总计: 'Grand Total (Shipping Cost Not Included)',
  采购意向已提交成功: 'Your order has been submitted. Supplier will contact you within 1-3 working days.',
  查看我的采购单: 'View My Orders',
  提交成功: 'Submission successful!',
  该产品已下架: 'Product removed.',
  该产品不存在: 'Product doesn’t exist.',
  序号: 'No',
  数量: 'Quantity',
  单位: 'Unit',
  单价: 'Unit Price',
  小计: 'Subtotal',
  请选择所需产品数量: 'Please choose quantity.',
  选择采购产品的分类: 'Please choose product category',
  找不到心仪的产品快来一键帮您采购下单: "Can't find what you are looking for? Let us help!",
  进行查看: ' ',
  去发布招标: 'Publish a Tender Now',
  未匹配到符合的企业展品提示1: 'Sorry. No matching products found.',
  未匹配到符合的企业展品提示2:
    'You can publish a tender on our website. Interested suppliers may contact you very soon!',
  暂无匹配: 'No match yet.',
  会员中心我的采购: 'My Account>My Orders',
  推荐匹配的展品说明1:
    'Based on your interested product categories,Based on big data analysis,we have automatically generated',
  推荐匹配的展品说明2: 'orders for you., You can find it in',
  一级行业二级行业: 'Primary Industry/Secondary Industry',
  系统正在努力匹配中: 'Searching Now. Please Wait....',
  下单成功: 'Order Successful',
  '3D': '3D',
  产品视频: 'Product Video',
}
